import { createColumnHelper } from "@tanstack/react-table";

import { PlayerStats } from "@/lib/types";
import { numberFormat, percentageFormat } from "@/lib/utils";

interface CreateColumnsProps {
  handleClick: (p: PlayerStats) => void;
}

const columnHelper = createColumnHelper<PlayerStats>();

export const createColumns = ({ handleClick }: CreateColumnsProps) => {
  return [
    columnHelper.accessor("pitchType", {
      header: () => "Type",
      cell: ({ row }) => {
        const playerStats = row.original;

        return (
          <button
            onClick={() => handleClick(playerStats)}
            className="hover:cursor-pointer bg-transparent border-none p-0 text-left"
          >
            {playerStats.pitchType}
          </button>
        );
      },
    }),
    columnHelper.accessor("count", {
      header: () => "Count",
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("percentage", {
      header: () => "%",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("leftHandPercentage", {
      header: () => "LHH %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("rightHandPercentage", {
      header: () => "RHH %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("averageVelocity", {
      header: () => "Velo",
      cell: (info) => numberFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("peakVelocity", {
      header: () => "Peak",
      cell: (info) => numberFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("foulsPercentage", {
      header: () => "Fouls %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("bipPercentage", {
      header: () => "BIP %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("onePkPercentage", {
      header: () => "1PK %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("zonePercentage", {
      header: () => "Zone %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("edgePercentage", {
      header: () => "Edge %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("izWhiffPercentage", {
      header: () => "IZ Whiff %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
    columnHelper.accessor("chasePercentage", {
      header: () => "Chase %",
      cell: (info) => percentageFormat(info.getValue()),
      meta: {
        align: "right",
      },
    }),
  ];
};
